module.exports = function (bond) {
    if (bond <= 100000) {
        return 45;
    } else if (bond <= 200000) {
        return 101;
    } else if (bond <= 300000) {
        return 642;
    } else if (bond <= 600000) {
        return 800;
    } else if (bond <= 800000) {
        return 1126;
    } else if (bond <= 1000000) {
        return 1293;
    } else if (bond <= 2000000) {
        return 1453;
    } else if (bond <= 4000000) {
        return 2014;
    } else if (bond <= 6000000) {
        return 2443;
    } else if (bond <= 8000000) {
        return 2909;
    } else if (bond <= 10000000) {
        return 3401;
    } else if (bond <= 15000000) {
        return 4048;
    } else if (bond <= 20000000) {
        return 4863;
    } else {
        return 6477;
    }
};
